module.exports = __webpack_public_path__ + "static/media/DSC01469.7c6417bd.jpg";